import React, { useEffect, useState } from 'react';
import * as global from './global';

export const writeLogMsg = (text, objet) => {
    if (global.APP_LOG_ENABLED) {
        if (objet) {
            console.log(text, objet);
        } else {
            // If no object is provided, just log the text
            console.log(text);
        }
    }}